var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1115_2392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.769226H3.75C1.67893 0.769226 0 2.44816 0 4.51923V13.0192C0 15.0903 1.67893 16.7692 3.75 16.7692H12.25C14.3211 16.7692 16 15.0903 16 13.0192V4.51923C16 2.44816 14.3211 0.769226 12.25 0.769226Z",
    fill: "url(#paint0_radial_1115_2392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.769226H3.75C1.67893 0.769226 0 2.44816 0 4.51923V13.0192C0 15.0903 1.67893 16.7692 3.75 16.7692H12.25C14.3211 16.7692 16 15.0903 16 13.0192V4.51923C16 2.44816 14.3211 0.769226 12.25 0.769226Z",
    fill: "url(#paint1_radial_1115_2392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00056 2.51923C6.30319 2.51923 6.09013 2.52666 5.4235 2.55698C4.75813 2.58748 4.30394 2.69279 3.90656 2.84735C3.49544 3.00698 3.14675 3.22054 2.79938 3.56804C2.45169 3.91548 2.23813 4.26416 2.078 4.6751C1.923 5.0726 1.81756 5.52698 1.78762 6.19204C1.75781 6.85873 1.75 7.07185 1.75 8.76929C1.75 10.4667 1.7575 10.6791 1.78775 11.3457C1.81838 12.0111 1.92369 12.4653 2.07812 12.8627C2.23787 13.2738 2.45144 13.6225 2.79894 13.9699C3.14625 14.3175 3.49494 14.5316 3.90575 14.6912C4.30344 14.8458 4.75769 14.9511 5.42294 14.9816C6.08962 15.0119 6.3025 15.0194 7.99981 15.0194C9.69738 15.0194 9.90975 15.0119 10.5764 14.9816C11.2417 14.9511 11.6964 14.8458 12.0941 14.6912C12.5051 14.5316 12.8532 14.3175 13.2005 13.9699C13.5482 13.6225 13.7617 13.2738 13.9219 12.8629C14.0755 12.4653 14.181 12.011 14.2122 11.3459C14.2422 10.6792 14.25 10.4667 14.25 8.76929C14.25 7.07185 14.2422 6.85885 14.2122 6.19216C14.181 5.52679 14.0755 5.07266 13.9219 4.67529C13.7617 4.26416 13.5482 3.91548 13.2005 3.56804C12.8529 3.22041 12.5052 3.00685 12.0938 2.84741C11.6953 2.69279 11.2409 2.58741 10.5755 2.55698C9.90881 2.52666 9.69656 2.51923 7.99862 2.51923H8.00056ZM7.43988 3.64554C7.60631 3.64529 7.792 3.64554 8.00056 3.64554C9.66938 3.64554 9.86712 3.65154 10.5261 3.68148C11.1355 3.70935 11.4663 3.81116 11.6866 3.89673C11.9783 4.00998 12.1862 4.14541 12.4048 4.36423C12.6236 4.58298 12.7589 4.79129 12.8725 5.08298C12.9581 5.30298 13.06 5.63373 13.0878 6.2431C13.1177 6.90198 13.1242 7.09985 13.1242 8.76785C13.1242 10.4359 13.1177 10.6338 13.0878 11.2926C13.0599 11.902 12.9581 12.2327 12.8725 12.4528C12.7593 12.7445 12.6236 12.9522 12.4048 13.1708C12.1861 13.3895 11.9784 13.5249 11.6866 13.6382C11.4665 13.7242 11.1355 13.8257 10.5261 13.8536C9.86725 13.8835 9.66938 13.89 8.00056 13.89C6.33169 13.89 6.13387 13.8835 5.47506 13.8536C4.86569 13.8255 4.53494 13.7237 4.31444 13.6381C4.02281 13.5248 3.81444 13.3894 3.59569 13.1707C3.37694 12.9519 3.24156 12.7441 3.128 12.4523C3.04244 12.2322 2.9405 11.9015 2.91275 11.2921C2.88281 10.6332 2.87681 10.4354 2.87681 8.76629C2.87681 7.09723 2.88281 6.90041 2.91275 6.24154C2.94062 5.63216 3.04244 5.30141 3.128 5.0811C3.24131 4.78941 3.37694 4.5811 3.59575 4.36235C3.81456 4.1436 4.02281 4.00816 4.3145 3.89466C4.53481 3.80873 4.86569 3.70716 5.47506 3.67916C6.05162 3.6531 6.27506 3.64529 7.43988 3.64398V3.64554ZM11.3368 4.68329C10.9228 4.68329 10.5868 5.01891 10.5868 5.43304C10.5868 5.8471 10.9228 6.18304 11.3368 6.18304C11.7509 6.18304 12.0868 5.8471 12.0868 5.43304C12.0868 5.01898 11.7509 4.68304 11.3368 4.68304V4.68329ZM8.00056 5.5596C6.22806 5.5596 4.79094 6.99673 4.79094 8.76929C4.79094 10.5419 6.22806 11.9783 8.00056 11.9783C9.77312 11.9783 11.2098 10.5419 11.2098 8.76929C11.2098 6.99679 9.773 5.5596 8.00044 5.5596H8.00056ZM8.00056 6.68591C9.15112 6.68591 10.0839 7.6186 10.0839 8.76929C10.0839 9.91985 9.15112 10.8527 8.00056 10.8527C6.85 10.8527 5.91725 9.91985 5.91725 8.76929C5.91725 7.6186 6.84994 6.68591 8.00056 6.68591Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1115_2392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.25 18.0015) rotate(-90) scale(15.8572 14.7484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1115_2392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.68006 1.92179) rotate(78.681) scale(7.08825 29.218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1115_2392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.769226)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e031f31d87a21200368b69920cb79bb5.svg";
export { ForwardRef as ReactComponent };